import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SuperSocials } from '@/app/pages/admin-options/settings/molecules/super-socials/super-socials';

@Component({
  selector: 'ins-creator-socials',
  imports: [SuperSocials],
  templateUrl: './socials.html',
  host: { class: 'block h-full min-h-0 w-full min-w-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreatorSocials implements OnInit {
  private route = inject(ActivatedRoute);
  readonly creatorId = signal<string | undefined>(undefined);

  ngOnInit(): void {
    this.creatorId.set(this.route.parent?.snapshot.paramMap.get('creatorId') ?? undefined);
  }
}
